import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { PromptTypeOption } from 'src/app/pages/prompt-register/models/prompt-type-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { promptTypeOptionActions } from '../state/prompt-type-option.actions';
import { promptTypeOptionSelectors } from '../state/prompt-type-option.reducer';

@Directive({
    selector: '[ndtPromptTypeSelect]',
    standalone: false
})
export class PromptTypeSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<PromptTypeOption>,
      private statusService: NgrxEagerSelectService<AppState, PromptTypeOption>
   ) {}

   ngAfterViewInit(): void {
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            promptTypeOptionActions,
            promptTypeOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('typeName', this.trigger);
            },
            undefined
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
